import { ApiType } from "@gymflow/common";
import { TokenPageableRequestParams } from "@gymflow/types";
import { useInfiniteQuery } from "@tanstack/react-query";

import { smsQueryKeys } from "./smsQueryKeys";

export const useInfiniteQueryCreditsHistoryTopUps = ({
  api,
  params,
  refetchOnWindowFocus = false,
  enabled,
}: {
  api: ApiType;
  params: TokenPageableRequestParams;
  refetchOnWindowFocus?: boolean;
  enabled: boolean;
}) => {
  return useInfiniteQuery({
    queryKey: smsQueryKeys.getCreditsHistoryTopUps(params),
    queryFn: async ({ pageParam }: { pageParam?: string }) =>
      (
        await api.smsApi.getCreditsHistoryTopUps({
          ...params,
          nextPageToken: pageParam,
        })
      ).data,
    getNextPageParam: (lastPage) => lastPage?.nextPageToken,
    refetchOnWindowFocus,
    initialPageParam: undefined,
    enabled,
  });
};
